import { render, staticRenderFns } from "./sAddPersonRm.vue?vue&type=template&id=7da61624"
import script from "./sAddPersonRm.vue?vue&type=script&lang=js"
export * from "./sAddPersonRm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports